import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, spacing } from "@mui/system";
import { Prompt } from "react-router-dom";

import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField as MuiTextField,
  Typography,
  TextField,
  FormControl,
  NativeSelect,
  Input,
  TextareaAutosize,
  OutlinedInput,
  Button,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";

function NotaFiscalConfigurationNFSE({
  nfConfiguration,
  loadConfig,
  setIsDirtyData,
}) {
  let {
    getApi,
    postApi,
    putApi,
    user,
    signUpStep2,
    isBSAccount,
    isInitializedBS,
  } = useAuth();
  const [issuer_enabled, setissuerEnabled] = React.useState(1);
  const [providerId, setProviderId] = React.useState(1);
  let [saving, setSaving] = useState(false);

  const [nfsLote, setNfsLote] = React.useState(1);
  const [nfsNumero, setNfsNumero] = React.useState(1);
  const [nfsSerie, setNfsSerie] = React.useState(1);

  useEffect(() => {
    if (nfConfiguration) {
      if (nfConfiguration.nfs) {
        setissuerEnabled(nfConfiguration.nfs.issuer_enabled);
        setProviderId(nfConfiguration.nfs.provider.id);

        setNfsLote(nfConfiguration.nfs.rps_lote);
        setNfsNumero(nfConfiguration.nfs.rps_numero);
        setNfsSerie(nfConfiguration.nfs.rps_serie);
      }
    }
  }, [nfConfiguration]);

  useEffect(() => {
    if (
      issuer_enabled !== nfConfiguration.nfs.issuer_enabled ||
      providerId !== nfConfiguration.nfs.provider.id ||
      nfsLote !== nfConfiguration.nfs.rps_lote ||
      nfsNumero !== nfConfiguration.nfs.rps_numero ||
      nfsSerie !== nfConfiguration.nfs.rps_serie
    ) {
      setIsDirtyData(true);
    } else {
      setIsDirtyData(false);
    }
  }, [
    issuer_enabled,
    providerId,
    nfsLote,
    nfsNumero,
    nfsSerie,
    nfConfiguration.nfs,
  ]);

  const saveNfsTaxsData = async () => {
    setSaving(true);
    let response = await putApi("/nf/configuration", {
      nfs: {
        config: {
          issuer_enabled: issuer_enabled,
          providerId: providerId,
          nfsLote: parseInt(nfsLote),
          nfsNumero: parseInt(nfsNumero),
          nfsSerie: nfsSerie,
        },
      },
    });
    loadConfig();
    setSaving(false);
    alert("Dados salvos");
  };
  const handleKeyDownRemoveString = (e) => {
    if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
      e.preventDefault(); // Impede a digitação de qualquer coisa que não seja número
    }
  };

  return (
    <React.Fragment>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Configuração Nota Fiscal de Serviço
        </Typography>
        <Grid container>
          <Grid sm={12} md={5}>
            <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-issueStatus" sx={{ fontWeight: "bold" }}>
                  Habilitar Emissão de NFS-e
                </FormLabel>
                <RadioGroup
                  onChange={(e) => setissuerEnabled(e.target.value)}
                  value={issuer_enabled}
                  sx={{ marginLeft: 1 }}
                  row
                  aria-labelledby="lbl-issueStatus"
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Habilitado"
                  />
                  <FormControlLabel
                    value={0}
                    control={<Radio />}
                    label="Desativado"
                  />
                  <FormControlLabel
                    value={2}
                    control={<Radio />}
                    label="Desativado por erro"
                    disabled
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-incluirnotes" sx={{ fontWeight: "bold" }}>
                  Como deve emitir a NFS ?
                </FormLabel>
                <RadioGroup
                  onChange={(e) => setProviderId(e.target.value)}
                  value={providerId}
                  sx={{ marginLeft: 1 }}
                  row
                  aria-labelledby="lbl-issueStatus"
                >
                  <FormControlLabel
                    value={1}
                    control={<Radio />}
                    label="Via Portal Nacional"
                  />
                  <FormControlLabel
                    value={0}
                    control={<Radio />}
                    label="Via prefeitura."
                    disabled={nfConfiguration.tax_mei == true}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-ambiente">
                  Numeração de lote, série e RPS
                </FormLabel>
                <Box
                  component="form"
                  sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                  noValidate
                  autoComplete="off"
                >
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="input-nfs-lote">Lote *</InputLabel>
                    <OutlinedInput
                      id="input-nfs-lote"
                      onKeyDown={handleKeyDownRemoveString}
                      onChange={(e) => setNfsLote(e.target.value)}
                      value={nfsLote}
                      inputProps={{ maxLength: 5, inputMode: "numeric", pattern: "[0-9]*" }}
                    />
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="input-nfs-serie">Serie *</InputLabel>
                    <OutlinedInput
                      id="input-nfs-serie"
                      onChange={(e) => setNfsSerie(e.target.value)}
                      value={nfsSerie}
                    />
                  </FormControl>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="input-nfs-numero">Numero *</InputLabel>
                    <OutlinedInput
                      id="input-nfs-numero"
                      onKeyDown={handleKeyDownRemoveString}
                      onChange={(e) => setNfsNumero(e.target.value)}
                      value={nfsNumero}
                    />
                  </FormControl>
                </Box>
              </FormControl>
              {
                <Typography variant="caption" gutterBottom>
                  Primeira vez emitindo nota? Defina Lote = 1000 | Serie = 1 |
                  Numero = 1
                </Typography>
              }
            </Grid>

            {/* <Grid
              item
              style={{
                paddingTop: 16,
              }}
            >
              <FormControl fullWidth>
                <FormLabel id="lbl-incluirnotes" sx={{ fontWeight: "bold" }}>
                  Incluir nas minhas notas fiscais e observações
                </FormLabel>
                <TextareaAutosize
                  required
                  minRows={4}
                  aria-labelledby="lbl-incluirnotes"
                  label="Incluir nas minhas notas fiscais e observações"
                />
              </FormControl>
            </Grid> */}
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-start">
          <Grid item>
            {saving && (
              <Box sx={{ display: "flex" }}>
                <CircularProgress />
              </Box>
            )}
          </Grid>
        </Grid>
        <br />
        <Button
          variant="contained"
          color="primary"
          mt={3}
          onClick={(e) => saveNfsTaxsData()}
          disabled={saving}
        >
          Atualizar Dados
        </Button>
      </CardContent>
    </React.Fragment>
  );
}

export default NotaFiscalConfigurationNFSE;
